import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, ButtonToolbar } from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';
import { css } from 'glamor';
import BaseLoader from '../../../_Common/BaseLoader';
import RawMatInformationForm from './RawMatInformationForm';

const styles = {
  buttonPanel: css({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '0px',
    marginBottom: '0px',
    marginRight: '17px',
    marginLeft: '17px',
  }),
};

const RawMatInformationModal = props => (
  <div>
    <Modal.Header closeButton>
      <Modal.Title>{I18n.t('modal.rmInfoForm.title')}</Modal.Title>
    </Modal.Header>
    <BaseLoader isLoading={props.isLoading}>
      <Modal.Body>
        <RawMatInformationForm rawMatId={props.rawMatId} rawMatPhraseId={props.rawMatPhraseId} />
      </Modal.Body>
    </BaseLoader>
    <Modal.Footer>
      <div className={styles.buttonPanel}>
        <ButtonToolbar>
          <Button bsSize="small" bsStyle="danger" type="button" onClick={props.closeModal}>
            <i className="fa fa-times" />&nbsp;
            <Translate value="general.close" />
          </Button>
          <Button
            bsSize="small"
            bsStyle="success"
            type="button"
            onClick={props.onSaveButtonClick}
            disabled={props.isSaveDisabled}
          >
            <Translate value="general.save" />&nbsp;
            <i className="fa fa-arrow-circle-right" />
          </Button>
        </ButtonToolbar>
      </div>
    </Modal.Footer>
  </div>
);

RawMatInformationModal.defaultProps = {
  rawMatPhraseId: undefined,
};

RawMatInformationModal.propTypes = {
  onSaveButtonClick: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaveDisabled: PropTypes.bool.isRequired,
  rawMatId: PropTypes.number.isRequired,
  rawMatPhraseId: PropTypes.number,
};

export default RawMatInformationModal;
